var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.68076 4.2059L10.5664 2.32029L13.8662 5.62012L11.9806 7.50574M8.68076 4.2059L2.37399 10.5127C2.18645 10.7002 2.0811 10.9546 2.0811 11.2198L2.0811 14.1054L4.96672 14.1054C5.23193 14.1054 5.48629 14 5.67382 13.8125L11.9806 7.50574M8.68076 4.2059L11.9806 7.50574",
    stroke: "#010101",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditPencil);
export default __webpack_public_path__ + "static/media/editPencil .d637142cc7c1a78f3dd9199a6e4bd6d6.svg";
export { ForwardRef as ReactComponent };